/* -------------------------------------------
    IMAGE ZOOM 
------------------------------------------- */

const addZoomListeners = () => {
  if (window.innerWidth < 768) return;

  const zoomImageEls = document.querySelectorAll(".js-imageZoom");

  zoomImageEls.forEach((el) => {
    el.setAttribute(
      "style",
      `background-image:url(${el.getAttribute("data-zoom-source")})`
    );
    el.classList.add("has-zoomlistener");
  });

  if (zoomImageEls.length) {
    // const zoomImage = (e) => {
    //   e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
    //   e.offsetY ? (offsetY = e.offsetY) : (offsetY = e.touches[0].pageY);
    //   x = (offsetX / e.currentTarget.offsetWidth) * 100;
    //   y = (offsetY / e.currentTarget.offsetHeight) * 100;
    //   e.currentTarget.style.backgroundPosition = x + "% " + y + "%";
    // };

    const zoomImage = (e) => {
      let offsetX, offsetY; // Declare variables here
      if (e.offsetX) {
        offsetX = e.offsetX;
        offsetY = e.offsetY;
      } else if (e.touches && e.touches[0]) {
        offsetX = e.touches[0].pageX;
        offsetY = e.touches[0].pageY;
      } else {
        return; // If neither is available, exit the function gracefully
      }

      const x = (offsetX / e.currentTarget.offsetWidth) * 100;
      const y = (offsetY / e.currentTarget.offsetHeight) * 100;
      e.currentTarget.style.backgroundPosition = `${x}% ${y}%`;
    };

    zoomImageEls.forEach((el) =>
      el.addEventListener("mousemove", (e) => {
        zoomImage(e);
      })
    );
  }
};

window.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".js-imageZoom")) {
    addZoomListeners();
  }
});

window.addEventListener("addImageZoom", () => {
  if (document.querySelector(".js-imageZoom")) {
    addZoomListeners();
  }
});

const addZoomListenerButtons = document.querySelectorAll(".js-initZoom");

if (addZoomListenerButtons) {
  addZoomListenerButtons.forEach((btn) =>
    btn.addEventListener("click", () => {
      setTimeout(() => {
        addZoomListeners();
      }, 1000);
    })
  );
}
